export default "__VITE_ASSET__CRW0FDjU__"